import { createSlice } from '@reduxjs/toolkit';
import * as actions from './actions';

const authSlice = createSlice({
	name: 'auth',
	initialState: {
		isAuthenticated: false,
		loading: false,
		token: null,
		displayName: '',
		loginUserName: '',	
		refreshToken: null,
		clientInfo: {
			adUserName: '',
			machineName: '',
			error: ''
		},
		computerName: '',
		isAdmin: false
	},
	reducers: {
		logoutUser(state) {
			state.isAuthenticated = false;
			state.loading = false;
			state.token = null;
			state.refreshToken = null;
			state.displayName = '';
			state.loginUserName = '';
			state.clientInfo.adUserName = '';
			state.clientInfo.machineName = '';
			state.clientInfo.error = '';
			state.showManualLogin = false;
			state.computerName = '';
			state.isAdmin = false;
		}
	},
	extraReducers: (builder) => {
		// User Login
		builder.addCase(actions.userLogin.pending, state => {
			state.loading = true;
		})
		builder.addCase(actions.userLogin.fulfilled, (state, action) => {
			if (action.payload.success) {
				const { token, displayName, loginUserName, refreshToken, isAdmin } = action.payload.data || {};
				state.isAuthenticated = true;
				state.token = token;
				state.refreshToken = refreshToken;
				state.displayName = displayName;
				state.loginUserName = loginUserName;			
				state.isAdmin = isAdmin;
			} else {
				state.isAuthenticated = false;
				state.token = null;
				state.refreshToken = null;
				state.displayName = '';
				state.isAdmin = false;
			}
			state.loading = false;
		})
		builder.addCase(actions.userLogin.rejected, state => {
			state.loading = false;
			state.isAuthenticated = false;
			state.token = null;
			state.refreshToken = null;
			state.displayName = '';
			state.loginUserName = '';
			state.isAdmin = false;
		})

		builder.addCase(actions.getNewToken.pending, state => {
			state.loading = true;
		})
		builder.addCase(actions.getNewToken.fulfilled, (state, action) => {
			const { token } = action.payload || {};
			state.token = token;
			state.loading = false;
		})
		builder.addCase(actions.getNewToken.rejected, state => {
			state.loading = false;
			state.isAuthenticated = false;
			state.token = null;
			state.refreshToken = null;
			state.displayName = '';
			state.loginUserName = '';
			state.isAdmin = false;
		})	
	}
});

export const { logoutUser } = authSlice.actions

export default authSlice.reducer;
